type Props = {
    title: string;
    image: string;
};

export function CategoryImageTitle({ title, image }: Props) {
    return (
        <div className={'relative overflow-hidden'}>
            <img
                src={image}
                alt={title}
                className={'object-cover w-[230px] h-[180px] rounded-lg'}
                loading="lazy"
            />
            <p
                className={
                    'absolute inset-0 flex items-center justify-center text-md font-semibold mb-3 text-white text-center'
                }
            >
                {title}
            </p>
        </div>
    );
}
